import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DealService } from '../../services/deal.service';
import {
  LoadBidResultsFail,
  LoadBidResultsSuccess,
  LoadBidResults,
  BidResultsActionTypes
} from './actions';

@Injectable()
export class BidResultsEffects {
  @Effect()
  public loadBidResults$: Observable<
    LoadBidResultsSuccess | LoadBidResultsFail
  > = this.actions$.pipe(
    ofType(BidResultsActionTypes.LoadBidResults),
    switchMap((action: LoadBidResults) =>
      this.dealService.getBidResults(action.payload).pipe(
        map(({ bidResult }) => new LoadBidResultsSuccess(bidResult)),
        catchError((error) => of(new LoadBidResultsFail(error.message)))
      )
    )
  );

  constructor(public dealService: DealService, private actions$: Actions) {}
}
